module.exports = __webpack_public_path__ + "img/SketchPng9e1a2cb3a182f30d530ffc5513d1dfb64b59882f44e91958744b04c3aeab0a3b.24c7e92c.png";